// ZimbraUser.ts
import { UtilityService } from '../_service/utility.service';
import User       from './User';
import ZimbraInstance       from './ZimbraInstance';
export default class ZimbraUser extends User {
    
    zimbra_instance : ZimbraInstance = new ZimbraInstance();

    constructor(dict = null)
    {
      super(dict);
      if (dict !== null)
      {
         if (!UtilityService.empty(dict["zimbra"]))
         {
             this.zimbra_instance = new ZimbraInstance(dict["zimbra"]);
         }
      }
    }

  }
